module.exports = __webpack_public_path__ + "img/hong-kong.d896ba9a.svg";